import { AbsenceReportApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { EmployeeLeaveBalanceDto } from '../../../commonTypes/reports.types';
import { fetchAllReportRows } from '../../../util/exportHelper';

export interface IGetLeaveBalanceForExportQuery {
    leaveType: string;
    search?: string;
    projectId?: string;
}

const useHttpGetEmployeeLeaveBalanceForExport = () => {
    const absenceReportApi: AbsenceReportApi = useContainer(AbsenceReportApi);

    const exec = (query: IGetLeaveBalanceForExportQuery): Promise<EmployeeLeaveBalanceDto[]> =>
        fetchAllReportRows(
            (page, size) =>
                new Promise((resolve, reject) => {
                    const { exec } = absenceReportApi.getEmployeeLeaveBalance({
                        query: { ...query, page, size },
                        onSuccess: res => resolve(res.body),
                        onError: reject,
                    });
                    exec();
                })
        );

    return { exec };
};

export default useHttpGetEmployeeLeaveBalanceForExport;
